var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container py-4 px-2" }, [
    _c("h1", [_vm._v("Covid-19 Safety Agreement")]),
    _vm._v(" "),
    _vm.$i18n.locale === "th"
      ? _c("section", [
          _c("div", { staticClass: "py-4" }, [
            _vm._v("อัพเดทเมื่อ: 9 สิงหาคม 2564")
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n      เนื่องด้วยตระหนักถึงสถานการณ์การแพร่ระบาดของโรคโควิด19 ในปัจจุบันที่เพิ่มขึ้น ทางบริษัท บีนีท จำกัด\n      ได้เพิ่มมาตรการด้านความปลอดภัยในการให้บริการของผู้ให้บริการ เช่น กำหนดให้ผู้ให้บริการใส่หน้ากากอนามัย-ถุงมือ\n      ในขณะให้บริการ รวมทั้งตรวจวัดอุณหภูมิร่างกายเป็นประจำ และให้หยุดการให้บริการทันทีเมื่อผู้ให้บริการ\n      หรือคนในครอบครัวมีอาการป่วย\n    "
            )
          ]),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n      ท่านรับทราบและยอมรับเงื่อนไขในการใช้บริการนี้โดยยินดีร่วมมือในการปฏิบัติตาม\n      และยินดีรับผิดชอบที่จะดูแลความปลอดภัยของตัวท่านเอง เพื่อความปลอดภัยของทั้งตัวท่าน และผู้ให้บริการ\n    "
            )
          ])
        ])
      : _c("section", [
          _c("div", { staticClass: "py-4" }, [_vm._v("Update: 9 August 2021")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n      Due to the awareness of the epidemic situation of COVID-19, the company has increased safety protocol of service\n      providers, such as requiring service providers to wear masks - gloves during the service, check body temperature\n      regularly, and stop the service immediately when the service provider or family members have the illness\n      symptoms.\n    "
            )
          ]),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n      You acknowledge and accept these terms of use by agreeing to comply with them. And willing to take\n      responsibility for taking care of your safety.\n    "
            )
          ])
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("strong", [
        _c("u", [
          _vm._v(
            "อย่างไรก็ตามการใช้บริการใดๆที่มีการใกล้ชิดกับตัวบุคคลยังอาจมีความเสี่ยง\n        ดังนั้นผู้ใช้บริการจะต้องไม่ประมาท และต้องป้องกันสุขภาพส่วนตัว\n        ด้วยการไม่ละเลยต่อมาตรการความปลอดภัยตามคำแนะนำของหน่วยงานสาธารณสุข"
          )
        ])
      ]),
      _vm._v(
        " เช่น\n      การสวมหน้ากากอนามัยทุกครั้งในขณะที่ผู้ให้บริการทำความสะอาดในสถานที่ของท่าน\n      และต้องรักษาระยะห่างระหว่างตัวท่านเองกับผู้ให้บริการ หมั่นล้างมืออยู่เสมอ และถ้าหากท่านมีอาการป่วย ไม่สบาย\n      หรือมีประวัติใกล้ชิดผู้ป่วยหรือผู้ที่มีความเสี่ยง\n      ท่านจะต้องงดใช้บริการเป็นการชั่วคราวเพื่อดำเนินการตามนโยบายการป้องกันการแพร่ระบาดของโรค\n    "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("strong", [
        _c("u", [
          _vm._v(
            "However, using any services that are in close contact with a person can still be risky. Therefore,\n        customers must be aware of and protect personal health by not neglecting the safety protocol recommended by\n        the public health agency."
          )
        ])
      ]),
      _vm._v(
        " For example, always wear a mask all the time while the service provider\n      is in your place, maintain a distance between yourself and the service provider. Wash your hands regularly.\n      Moreover, In the case you or your family members get sick or contact illness people, You need to suspend the\n      service to implement the epidemic prevention policy temporarily.\n    "
      )
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-77189ba6", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77189ba6","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/information/Covid19Terms.vue
// module id = 1462
// module chunks = 0